const AlertItemSkeleton = () => {
    return (
        <div className='shadow-main flex flex-col gap-4 rounded-xl border-b-2 border-gray-300 bg-white p-4'>
            <div className='flex items-start'>
                <div className='flex h-7 w-7 animate-pulse items-center justify-center rounded bg-gray-200' />
                <div className='flex-1 px-2'>
                    <div className='h-5 w-3/4 animate-pulse rounded bg-gray-200' />
                </div>
                <div className='h-2.5 w-2.5 animate-pulse rounded-full bg-gray-200' />
            </div>
            <div className='space-y-2'>
                <div className='h-4 w-full animate-pulse rounded bg-gray-200' />
                <div className='h-4 w-5/6 animate-pulse rounded bg-gray-200' />
            </div>
            <div className='flex items-center justify-between gap-2'>
                <div className='flex items-center gap-1'>
                    <div className='h-4 w-4 animate-pulse rounded bg-gray-200' />
                    <div className='h-3 w-16 animate-pulse rounded bg-gray-200' />
                </div>
                <div className='flex items-center gap-1'>
                    <div className='h-4 w-4 animate-pulse rounded bg-gray-200' />
                    <div className='h-3 w-12 animate-pulse rounded bg-gray-200' />
                </div>
            </div>
        </div>
    );
};

export default AlertItemSkeleton;

